module.exports = __webpack_public_path__ + "static/assets/bd5a04bf76d7b84caf61f6e01b63c1f1.png";